// src/com/trans_plan_launch/TransPlanLaunchDict.js
import { InputType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// 운송요청에 차량 지정
const DictToSetVeh = {
    planId : {
		id: 'planId', label: '배차번호',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // varchar(12)
    vehPlates : {
		id: 'vehPlates', label: '차량번호',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'vehPlates',
	}, // int(11)
};
// 운송요청 배차내역 테이블, trans_plan
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    planId : {
		id: 'planId', label: '배차번호',
		type: InputType.text, required: true, toAdd: false, toEdit: true,
	}, // varchar(12)
    dcCd : {
		id: 'dcCd', label: '출발지',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
	}, // varchar(3)
    storeId : {
		id: 'storeId', label: '도착지',
		type: InputType.select, required: true, toAdd: true, toEdit: false,
	}, // varchar(10)
    comId : {
		id: 'comId', label: '운송사',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'comName',
	}, // varchar(10)
    planDate : {
		id: 'planDate', label: '배차일자',
		type: InputType.date, required: true, toAdd: true, toEdit: false,
	}, // date
    hocha : {
		id: 'hocha', label: '호차',
		type: InputType.number, required: true, toAdd: true, toEdit: false,
		check: (value) => {return value >= 1 && value <= 999},
	}, // int(11)
    transTypeCd : {
		id: 'transTypeCd', label: '배차구분', // wave1,2,3
		type: InputType.select, required: false, toAdd: true, toEdit: true,
	}, // varchar(10)
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
		labelKey: 'vehTypeName',
	}, // varchar(10)
    shprReqTime : {
		id: 'shprReqTime', label: '접안시간',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    dptrReqTime : {
        id: 'dptrReqTime', label: '출발요청시간',
        type: InputType.datetime, required: true, toAdd: true, toEdit: true,
    }, // timestamp
    arrReqTime : {
        id: 'arrReqTime', label: '도착요청시간',
        type: InputType.datetime, required: true, toAdd: true, toEdit: true,
    }, // timestamp
    dockno : {
        id: 'dockno', label: 'Dock No.',
        type: InputType.text, required: true, toAdd: true, toEdit: true,
        placeholder: 'Dock No.',
        check: (value) => {return IsValid.string(value, 0, 3)},
    }, // varchar(3)
    addCharge : {
        id: 'addCharge', label: '추가운임',
        type: InputType.number, required: true, toAdd: true, toEdit: true,
        placeholder: '추가운임',
        check: (value) => {return value >= 0 && value <= 1000000},
    }, // int(11)
    note : {
        id: 'note', label: '비고',
        type: InputType.text, required: false, toAdd: true, toEdit: true,
        placeholder: '비고',
        check: (value) => {return IsValid.string(value, 0, 300)},
    }, // varchar(300)
    zipgiBool : {
		id: 'zipgiBool', label: '집기',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)

    // planTime : {}, // timestamp, now()
    /*
    arriveId : {
		id: 'arriveId', label: '운행지코드',
		type: InputType.select, required: false, toAdd: false, toEdit: false,
	}, // varchar(12)
    txStage : {
		id: 'txStage', label: 'txStage',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '8자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 8)},
	}, // enum('legacy','init','hold','open','assigned','running','arrived','done','cancel')
    vehTypeName : {
		id: 'vehTypeName', label: 'vehTypeName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '50자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 50)},
	}, // varchar(50)
    charge : {
		id: 'charge', label: 'charge',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    reqStateFlag : {
		id: 'reqStateFlag', label: 'Check common_code',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // char(1)
    transFlag : {
		id: 'transFlag', label: '배차(true) 또는 미배차',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)
    vehInfoSeq : {
		id: 'vehInfoSeq', label: 'vehInfoSeq',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    vehPlates : {
		id: 'vehPlates', label: 'vehPlates',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    driverName : {
		id: 'driverName', label: '암호화한 운전자 이름',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    driverMobile : {
		id: 'driverMobile', label: '암호화한 운전자 전화번호',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '64자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 64)},
	}, // varchar(64)
    bol1 : {
		id: 'bol1', label: 'bol1',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '18자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 18)},
	}, // varchar(18)
    bol2 : {
		id: 'bol2', label: 'bol2',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '18자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 18)},
	}, // varchar(18)
    bol3 : {
		id: 'bol3', label: 'bol3',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '18자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 18)},
	}, // varchar(18)
    loadCount : {
		id: 'loadCount', label: 'loadCount',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    loadStTime : {
		id: 'loadStTime', label: 'loadStTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    loadEnTime : {
		id: 'loadEnTime', label: 'loadEnTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    prosDptrTime : {
		id: 'prosDptrTime', label: 'prosDptrTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    prosArrTime : {
		id: 'prosArrTime', label: 'prosArrTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    sealNo1 : {
		id: 'sealNo1', label: 'sealNo1',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    sealNo2 : {
		id: 'sealNo2', label: 'sealNo2',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    sealNo3 : {
		id: 'sealNo3', label: 'sealNo3',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    loadStaffName : {
		id: 'loadStaffName', label: 'loadStaffName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '15자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 15)},
	}, // varchar(15)
    unsoldBol : {
		id: 'unsoldBol', label: 'unsoldBol',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '18자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 18)},
	}, // varchar(18)
    unsoldPallet : {
		id: 'unsoldPallet', label: 'unsoldPallet',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    unsoldCount : {
		id: 'unsoldCount', label: 'unsoldCount',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    memo : {
		id: 'memo', label: 'memo',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '400자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 400)},
	}, // varchar(400)
    inputArrTime : {
		id: 'inputArrTime', label: 'inputArrTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    traceStatus : {
		id: 'traceStatus', label: 'traceStatus',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)
    regTypeCd : {
		id: 'regTypeCd', label: '업로드(A), 수동(M), 요청(R)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // enum('R','A','M')
    endFlag : {
		id: 'endFlag', label: 'endFlag',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // char(1)
    inputDptrTime : {
		id: 'inputDptrTime', label: 'inputDptrTime',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    printDate : {
		id: 'printDate', label: 'printDate',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    printUser : {
		id: 'printUser', label: 'printUser',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	}, // varchar(40)
    inputTempF : {
		id: 'inputTempF', label: 'inputTempF',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '8자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 8)},
	}, // varchar(8)
    inputTempM : {
		id: 'inputTempM', label: 'inputTempM',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '8자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 8)},
	}, // varchar(8)
    inputTempR : {
		id: 'inputTempR', label: 'inputTempR',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '8자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 8)},
	}, // varchar(8)
    dcName : {
		id: 'dcName', label: 'dcName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    dcTypeCd : {
		id: 'dcTypeCd', label: 'dcTypeCd',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // enum('A','F','E')
    dcTypeName : {
		id: 'dcTypeName', label: 'dcTypeName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    comName : {
		id: 'comName', label: 'comName',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    transPosYn : {
		id: 'transPosYn', label: 'transPosYn',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    storeName : {
		id: 'storeName', label: 'storeName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    */
};

/**
 * TRANS_PLAN React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-02-11 11:02:49 using DbdbTap
 * https://www.dbdbtap.com
 */
export const TransPlanLaunchDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '운송요청 등록 오류',
        Edit: '운송요청 수정 오류',
        Remove: '운송요청 삭제 오류',
        Get: '운송요청 조회 오류',
    },
    inputMapToSetVeh: DictToSetVeh,
};
